import { lazy } from 'react';

export const LazyOnboardingUpsellPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--onboarding-upsell-page" */ './onboarding-upsell-page'
    ),
);
